import { CSSProperties, FC, useEffect, useState } from "react";
import styles from "./Highlight.module.scss";

interface IHighlightProps {
    enabled: boolean;
    offsetX?: string;
    offsetY?: string;
}

export const Highlight: FC<IHighlightProps> = ({ enabled, offsetX, offsetY }) => {
    const [blinking, setBlinking] = useState(true);

    useEffect(() => {
        if (!enabled) return;

        const timer = setTimeout(() => setBlinking(false), 5000);
        return () => clearTimeout(timer);
    }, [enabled]);

    if (!enabled) return null;

    return (
        <div 
            className={`${styles.ylwCircle} ${blinking ? styles.blinking : ""}`}
            style={{
                '--offset-x': offsetX || '0',
                '--offset-y': offsetY || '0',
            } as CSSProperties}
        />
    );
};